import '@tencent/exeditor3-ui-kit/dist/color-palette.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
import { isColor } from './helper.js';
export class BackgroundColorPlugin {
    constructor() {
        this.name = 'backgroundColor';
        this.spec = {
            type: 'mark',
            matchStyle: {
                background: (color) => (isColor(color) ? { color } : false),
                'background-color': (color) => (color ? { color } : false),
            },
            attrs: {
                color: {
                    toDOMAttribute: (color) => color ? { style: `background-color: ${color}` } : null,
                },
            },
            toDOM: 'span',
        };
        this.set = (color) => {
            if (color) {
                this.editor.selection().addMark(this, { color });
            }
            else {
                this.editor.selection().removeMark(this);
            }
        };
        this.get = () => this.editor.selection().getMarkAttrs(this).color;
        this.canApply = () => this.editor.selection().canToggleMark(this);
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            commands: {
                set: this.set,
                get: this.get,
            },
        };
    }
    renderPalette(btn, setIconColor) {
        const palette = document.createElement('exeditor-color-palette');
        palette.t = this.editor.t.bind(this.editor);
        palette.editor = this.editor;
        palette.slot = 'pop-content';
        palette.key = 'EXEDITOR_TEXT_COLOR';
        palette.addEventListener('pick', (e) => {
            const color = e.detail || '';
            palette.value = color;
            this.editor.focus();
            this.set(color);
            setIconColor(color);
            btn.closeDropdown();
        });
        return palette;
    }
    renderToolbarItem() {
        const btn = document.createElement('exeditor-toolbar-button');
        const icon = createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.bgColorIcon),
        });
        const setIconColor = (color) => {
            if (color) {
                icon.style.setProperty('--ex-color', color);
            }
            else {
                icon.style.removeProperty('--ex-color');
            }
        };
        setIconColor(this.get());
        const palette = this.renderPalette(btn, (color) => {
            setIconColor(color);
            this.editor.emit('updateBackgroundColorIconColor', { color });
        });
        btn.append(icon, palette);
        btn.addEventListener('buttonclick', () => {
            const recentColor = palette.value || this.get();
            recentColor && this.set(recentColor);
        });
        this.editor.on('updateBackgroundColorIconColor', ({ color }) => {
            setIconColor(color);
            palette.value = color;
        });
        Object.assign(btn, {
            label: this.editor.t('背景颜色'),
            separateDropdown: true,
        });
        const setBtnProps = () => {
            btn.disabled = !this.canApply();
        };
        setBtnProps();
        this.editor.on('idlechange', setBtnProps);
        return btn;
    }
}
//# sourceMappingURL=index.js.map